import React from 'react';
import "../../assets/css/master.css";

import TemplateDashboard from "../../components/TemplateDashboard";
// import HomeContent from "./components/HomeContent"
  
const Notas = () => {

    return (
    <>

        <TemplateDashboard pretitle="Vista general" title="Notas">
            {/* <HomeContent /> */}
        </TemplateDashboard>
        
    </>
    )
};
  
export default Notas;